<template>
  <transition name="modal-alert" duration="300" appear mode="out-in">
    <div class="modal-alert" :class="{ 'modal-alert-show': modalAlertActive }">
      <div class="btn-close" @click="modalClose">
        <img src="../../assets/images/modal/btn_close.svg" />
      </div>
      <div class="bg" @click="modalClose">
        <div class="box">
          <div class="message">
            <span>{{ modalAlertText }}</span>
          </div>
          <div class="btn-box">
            <base-button-type-1
              text="Confirm"
              @click="confirm"
            ></base-button-type-1>
            <base-button-type-1
              text="Cancle"
              @click="modalClose"
            ></base-button-type-1>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import BaseButtonType1 from '@/components/common/form-elemnets/BaseButtonType1'

export default {
  name: 'modal-alert',
  components: { BaseButtonType1 },
  methods: {
    modalClose() {
      this.$store.dispatch(types.SET_MODAL_ALERT, {
        active: false,
        text: '',
        returnProps: false
      })
    },
    confirm() {
      this.$store.commit(types.SET_MODAL_ALERT, {
        active: false,
        text: '',
        returnProps: true
      })
    }
  },
  computed: {
    ...mapGetters(['modalAlertActive', 'modalAlertText'])
  }
}
</script>

<style lang="scss" scoped>
.modal-alert {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 1000;
  display: none;
  opacity: 0;

  .bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    opacity: 0.9;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-close {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 80px;
    cursor: pointer;
    z-index: 1080;
    img {
      width: 80px;
      height: 80px;
    }
  }

  .box {
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    height: 50%;
    background-color: #ffffff;
    z-index: 1080;
    border: solid 1px #e7e7e7;
    display: flex;
    flex-direction: column;
    align-items: center;
    .message {
      height: 200px;
      width: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .btn-box {
      display: flex;
      justify-content: space-between;
      width: 50%;
      align-items: center;
    }
  }

  &.modal-alert-show {
    display: block;
    opacity: 1;
  }
}

.modal-alert-enter-active {
  transition: all 0.3s ease;
}

.modal-alert-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 0;
}

.modal-alert-fade-enter,
.modal-alert-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.modal-alert-show {
  display: block;
  opacity: 1;
}
</style>
